import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { Context,Hooks,Util,Request } from "@xt/xtbase";
const {XtContext,XtAuth} = Context;
const {useTranslation} = Hooks;
const {Big,getUrl,showRate} = Util;
const {XtSocketPublic} = Request;
import styles from "./star.module.less";
import { useStore } from '@/models';
import { observer } from 'mobx-react-lite';
import XtButton from "@/components/App/XtButton";
import Swal from "@/utils/swal";
import { post_fapiCollectionAdd, post_fapiCollectionCancel } from "@/api/futures";

const MarketListStar = ({ marketType, symbol, variant = "default", hideTip = false, pcRow = false, className }) => {
  const t = useTranslation();
  const [appState] = React.useContext(XtContext);
  const {market,user} = useStore();
  const [loading, setLoading] = useState(false);
  const [starId, setStarId] = useState("");
  const isStarred = starId !== "" && starId !== 0 && starId !== "0";
  useEffect(()=>{
    // 新的 tab 分类（optional/spot/fiat-m/usdt-m）和 coinMarket 都使用 userMarket
    if(marketType == "coinMarket" || marketType == "optional" || marketType == "spot" || marketType == "fiat-m" || marketType == "usdt-m")
    {
      const {loginStatus,userMarket} = user;
      if(loginStatus != 1) {
        setStarId("");
        return;
      }
      // 检查 symbol 是否在 userMarket 中
      const found = userMarket && userMarket.find((s)=>s == symbol);
      setStarId(found ? symbol : "");
    }
  },[user.userMarket, marketType, symbol]);
  useEffect(()=>{
    if(marketType == "contractMarket")
    {
      const {loginStatus,userContractMarket} = user;
      if(loginStatus != 1)
        setStarId(0);
      if(userContractMarket.find((m)=>m == symbol) != null)
        setStarId(1);
      else
        setStarId(0);
    }
  },[user.userContractMarket]);
  const onClick = (e)=>{
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    if(user.loginStatus != 1)
    {
      return Swal.fadeError(t("trade.plsLoginHtml"));
    }
    if(loading)
      return;
    setLoading(true);
    if(marketType == "contractMarket")
    {
      const wasStarred = starId != "" && starId != 0 && starId != "0";
      setStarId(wasStarred ? 0 : 1);
      if (wasStarred) {
        post_fapiCollectionCancel({
          isReturnResponse: true,
          data: {
            symbol
          },
          isXT2: true,
        })
          .then(({data}) => {
            if (data.error) {
              setStarId(1);
              return Swal.error(data.error.msg);
            }
            void user.getUserContractMarket();
          })
          .catch(() => {
            setStarId(1);
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        post_fapiCollectionAdd({
          isReturnResponse: true,
          data: {
            symbol
          },
          isXT2: true,
        })
          .then(({data}) => {
            if (data.error) {
              setStarId(0);
              return Swal.error(data.error.msg);
            }
            void user.getUserContractMarket();
          })
          .catch(() => {
            setStarId(0);
          })
          .finally(() => {
            setLoading(false);
          });
      }
    }
    else
    {
      const nextStarred = !isStarred;
      setStarId(nextStarred ? symbol : "");
      const p = nextStarred ? user.addUserMarket(symbol) : user.removeUserMarket(symbol);
      p.finally(() => {
        setLoading(false);
      });
    }
  }
  const isPc = variant === "pc";
  const starSize = isPc ? (pcRow ? 14 : 16) : 12;
  const filledClass = isStarred
    ? isPc
      ? styles["star-path--filledPc"]
      : styles["star-path--filled"]
    : isPc
      ? styles["star-path--emptyPc"]
      : styles["star-path--empty"];

  const tipText = t(isStarred ? "market.favRemove" : "market.addToFavorites");
  const starButtonClass = classNames(
    styles["trade-market__container__star"],
    isPc && styles["trade-market__container__star--pc"],
    pcRow && styles["trade-market__container__star--pcRow"],
    className
  );

  const starIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={starSize}
      height={starSize}
      viewBox="0 0 12 12"
      fill="none"
      aria-hidden="true"
    >
      <path
        className={filledClass}
        d="M5.364.928a.77.77 0 0 1 1.272 0l1.325 1.933c.1.147.248.254.418.304l2.248.663c.52.153.723.78.393 1.21L9.591 6.895a.77.77 0 0 0-.16.492l.065 2.342a.77.77 0 0 1-1.03.748l-2.208-.785a.77.77 0 0 0-.516 0l-2.208.785a.77.77 0 0 1-1.03-.748l.065-2.342a.77.77 0 0 0-.16-.492L.979 5.038a.77.77 0 0 1 .394-1.21l2.248-.663a.77.77 0 0 0 .418-.304z"
      />
    </svg>
  );

  if (hideTip) {
    return (
      <button
        type="button"
        className={classNames("btnTxt", starButtonClass)}
        aria-label={tipText}
        data-starred={isStarred ? "true" : "false"}
        onClick={onClick}
      >
        {starIcon}
      </button>
    );
  }

  // tip 放在右上
  return (
    <XtButton
      className={starButtonClass}
      tip={tipText}
      tipPlacement="top-right"
      onClick={(e) => {
        onClick(e);
      }}
    >
      {starIcon}
    </XtButton>
  );
}
export default observer(MarketListStar);